var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "search as-flex main-center cross-center" },
      [_c("searchInput")],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "navigator" }, [_c("navigator")], 1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo as-flex main-center cross-center" }, [
      _c("img", {
        attrs: {
          src: require("../assets/images/sidebar-logo.png"),
          width: "90%",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }